/**
 * Словарь фронта: window.i18n из head.volt (секции ControllerBase::
 * FRONT_DICTIONARY). t( key, params ) с плюрализацией через '|' -
 * зеркало Translator::t для русского.
 */
function pluralForm( n, forms ) {

    if( forms.length < 3 )
        return n === 1 ? forms[0] : ( forms[1] ?? forms[0] );

    const n10  = n % 10;
    const n100 = n % 100;

    if( n10 === 1 && n100 !== 11 )
        return forms[0];

    if( n10 >= 2 && n10 <= 4 && ( n100 < 12 || n100 > 14 ) )
        return forms[1];

    return forms[2];
}

export function t( key, params = {} ) {

    let line = window.i18n?.[ key ] ?? key;

    if( 'n' in params && line.includes('|') )
        line = pluralForm( Number( params.n ), line.split('|') );

    Object.keys( params ).forEach( name => {
        line = line.split( '{' + name + '}' ).join( String( params[ name ] ) );
    } );

    return line;
}

/**
 * Копейки в строку витрины: 18 500 ₽ (неразрывный пробел перед валютой).
 */
export function price( kopeks, withCurrency = true ) {

    const whole    = Math.floor( Math.abs( kopeks ) / 100 );
    const fraction = Math.abs( kopeks ) % 100;

    let number = whole.toString().replace( /\B(?=(\d{3})+(?!\d))/g, ' ' );

    if( fraction > 0 )
        number += ',' + String( fraction ).padStart( 2, '0' );

    if( kopeks < 0 )
        number = '-' + number;

    if( ! withCurrency )
        return number;

    const suffix = window.shop?.currencySuffix || '';

    return suffix ? number + ' ' + suffix : number;
}
